export const getStoredUser = () => {
  try {
    const raw =
      localStorage.getItem("user") ??
      sessionStorage.getItem("user");

    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getStoredRole = () =>
  getStoredUser()?.role_name ?? "";